module.exports = __webpack_public_path__ + "static/media/SplashBackground.2446f12f.png";